/** Padrão de grid decorativo. SVG puramente cosmético, sem semântica. */
interface GridPatternProps {
  size: number;
  step?: number;
  stroke?: string;
  strokeWidth?: number;
  opacity?: number;
  style?: React.CSSProperties;
  vertical?: boolean;
  horizontal?: boolean;
}

export function GridPattern({
  size,
  step = 10,
  stroke = 'currentColor',
  strokeWidth = 0.5,
  opacity = 0.04,
  style,
  vertical = true,
  horizontal = true,
}: GridPatternProps): JSX.Element {
  const count = Math.floor(size / step) + 1;
  const lines: JSX.Element[] = [];
  if (horizontal) {
    for (let i = 0; i < count; i += 1) {
      lines.push(
        <line
          key={`h-${i}`}
          x1="0"
          y1={i * step}
          x2={size}
          y2={i * step}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />,
      );
    }
  }
  if (vertical) {
    for (let i = 0; i < count; i += 1) {
      lines.push(
        <line
          key={`v-${i}`}
          x1={i * step}
          y1="0"
          x2={i * step}
          y2={size}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />,
      );
    }
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      role="presentation"
      aria-hidden
      // Decorativo: nunca deve capturar clique de quem está embaixo.
      style={{ opacity, pointerEvents: 'none', ...style }}
    >
      <title>Padrão decorativo</title>
      {lines}
    </svg>
  );
}
